// Sections of a specialist's file its tab shows as cards of their own (Legal's
// Planning), with their citations checkable in one click.
import type { ShownSection } from "../api/hooks/useProjectAgentStatus";
import { CitedBody } from "./CitedBody";
import { SectionBlock, SectionCard } from "./SpecialistRowSections";
import type { Citations } from "./useCitations";
import styles from "./StateSectionCards.module.css";

export const StateSectionCards = ({
  sections,
  citations,
  pastBriefing,
}: {
  sections: ShownSection[];
  /** The tab's one lookup over every body it shows. */
  citations: Citations;
  /** An earlier version, which no pass will now fill in. */
  pastBriefing: boolean;
}) => {
  if (sections.length === 0) return null;
  return (
    <>
      {sections.map((section) => (
        <SectionCard
          key={section.section_id}
          title={section.title}
          aside={null}
          id={section.section_id}
        >
          <SectionBlock>
            {section.body ? (
              <CitedBody
                body={section.body}
                citations={citations}
                className={styles.body}
              />
            ) : (
              <p className={styles.muted}>
                {pastBriefing
                  ? "Nothing was recorded here at this version."
                  : "Nothing recorded yet. The agent fills this in on its next pass."}
              </p>
            )}
          </SectionBlock>
        </SectionCard>
      ))}
    </>
  );
};
